function debounce(fn, delay = 300) {
  let timer;

  return function (...args) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

async function updateCartNote(note) {
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        note: note,
      }),
    });
  } catch (error) {
    console.error('Failed to update cart note:', error);
  }
}

const debouncedNoteUpdate = debounce((event) => {
  updateCartNote(event.target.value);
}, 300);

document.addEventListener('DOMContentLoaded', () => {
  const cartNote = document.querySelector('#cart-note');

  if (!cartNote) return;

  cartNote.addEventListener('input', debouncedNoteUpdate);
});